import localforage from "localforage"
import { useEffect, useState } from "react"

export type PreferencesType = {
  theme: "default" | "dark" | "light" | string
  offline_mode: boolean
  notification: boolean
  narrative: "default" | "custom"
}
export async function getPreferences() {
  const preferences = await localforage.getItem("preferences")

  if (preferences) return preferences as PreferencesType

  const defaultPreferences: PreferencesType = {
    theme: "light",
    offline_mode: false,
    notification: true,
    narrative: "default",
  }
  await localforage.setItem("preferences", defaultPreferences)

  return defaultPreferences
}
export async function set(values: Partial<PreferencesType>) {
  const preferences = await getPreferences()
  const newPreferences = { ...preferences, ...values }
  await localforage.setItem("preferences", newPreferences)
  if (typeof window !== "undefined") {
    window.dispatchEvent(new CustomEvent("preferences-updated", { detail: newPreferences }))
  }
}
export async function setPreferences(values: Partial<PreferencesType>) {
  const preferences = await getPreferences()
  const newPreferences = { ...preferences, ...values }
  await localforage.setItem("preferences", newPreferences)
  if (typeof window !== "undefined") {
    window.dispatchEvent(new CustomEvent("preferences-updated", { detail: newPreferences }))
  }
}

export function useGetPreferences() {
  const [preferences, setPreferences] = useState<PreferencesType>({
    theme: "default",
    offline_mode: false,
    notification: true,
    narrative: "default",
  })
  useEffect(() => {
    // if (preferences) return
    getPreferences().then(setPreferences)

    const handleUpdate = (e: Event) => {
      const customEvent = e as CustomEvent<PreferencesType>
      setPreferences(customEvent.detail)
    }

    if (typeof window !== "undefined") {
      window.addEventListener("preferences-updated", handleUpdate)
      return () => {
        window.removeEventListener("preferences-updated", handleUpdate)
      }
    }
  }, [])
  return preferences
}
